import * as React from 'react';
//import { useNavigate }  from 'react-router-dom';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Menu from '@mui/icons-material/Menu';
import {
    Link,
    AppBar as MuiAppBar,
    AppBarProps as MuiAppBarProps,
    styled,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import useTheme from '@mui/material/styles/useTheme';
import AccountMenu from 'ui/components/dashboard-components/AccountMenu';
import { drawerWidth } from 'ui/components/dashboard-components/LeftDrawer';
import { ToggleProps } from 'ui/components/Dashboard';
import MobileMenu from 'ui/components/dashboard-components/MobileMenu';
import {
    ReactComponent as FunexpectedIcon
} from 'images/funexpected.svg';
import {
    ReactComponent as ArrowBackIcon
} from 'images/arrow_back.svg';
//import {
//    TEACHERS_LANDING_LINK
//}                       from 'config/config';
import { useAuth } from 'auth/AuthProvider';
import { IProfileInfo } from 'models/IProfile';
import { HttpClient } from 'apiclient/ApiClient';
import { useQuery } from 'react-query';

function WidthNotToSmall() {
    return useMediaQuery('(min-width:425px)');
};

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled
    (
        MuiAppBar,
        { shouldForwardProp: (prop) => prop !== 'open', }
    )<AppBarProps>(({ theme, open }) => ({
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(
            ['width', 'margin'],
            {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }
        ),
        ...(open && {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(
                ['width', 'margin'],
                {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }
            ),
        }),
    }));

interface BackButtonProps {
    onBack?: () => void;
    backType?: 'all-reports' | 'school-report';
}

export default function TopBar(props: ToggleProps & {
    bgcolorLight?: string
    bgcolorDark?: string
    hideProfileMenu?: boolean
} & BackButtonProps) {
    const [openMobileMenu, setOpenMobileMenu] = React.useState(false);
    //const navigate = useNavigate()
    const theme = useTheme()
    const width_not_small = WidthNotToSmall();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const { session } = useAuth();
    let bgcolor = theme.palette.mode === 'light' ? theme.palette.background.paper : '#090910'
    if (props.bgcolorLight && theme.palette.mode === 'light') {
        bgcolor = props.bgcolorLight;
    } else if (props.bgcolorDark && theme.palette.mode === 'dark') {
        bgcolor = props.bgcolorDark;
    };
    const httpClient = HttpClient();
    const resp = useQuery(
        '/school/profile',
        async () => await httpClient.get<IProfileInfo>('/school/profile'),
        {
            enabled: props.open && !!session
        }
    );
    const profileInfo = resp.data;
    const userName = session?.visible_name || profileInfo?.name;
    //const nav = React.useCallback(() => {
    //    auth.session_token ? navigate('/') : window.location.href = TEACHERS_LANDING_LINK;
    //}, [auth.session_token, navigate]);

    const showBackButton = props.onBack && props.backType;
    const showFunexpectedLogo = !session || (!props.open && matches);
    const logoUrl = session && session.visible_name && session.visible_name.trim() !== '' ? "/classes" : "https://funexpectedapps.com/resources/";
    const getBackText = () => {
        if (props.backType === 'all-reports') return 'Back to All Reports';
        if (props.backType === 'school-report') return 'Back to School Report';
        return '';
    };

    return (
        <AppBar
            position="absolute"
            open={props.open}
            sx={{ boxShadow: 'none', backgroundColor: bgcolor }}
        >
            <Toolbar sx={{ pr: '24px', justifyContent: "left" }} >
                {showBackButton && (
                    <Box
                        onClick={props.onBack}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            pl: '20px',
                            '&:hover': {
                                opacity: 0.8
                            }
                        }}
                    >
                        <SvgIcon
                            component={ArrowBackIcon}
                            sx={{
                                width: '24px',
                                height: '24px',
                                color: '#4D4D4D',
                                mr: '24px'
                            }}
                        />
                        <Typography
                            sx={{
                                fontFamily: 'Geometria, Arial, sans-serif',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '24px',
                                letterSpacing: '0%',
                                color: '#4D4D4D',
                                width: '180px',
                                height: '24px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {getBackText()}
                        </Typography>
                    </Box>
                )}
                {showFunexpectedLogo &&
                    <Link href={logoUrl}>
                        <IconButton
                            disableRipple
                            disableFocusRipple
                            disableTouchRipple
                            edge="start"
                            color="inherit"
                            style={{ backgroundColor: 'transparent' }}
                            // onClick={() => {window.location.href = logoUrl}}
                            sx={
                                width_not_small ?
                                    { width: 280, justifyContent: "flex-start", pl: 3, flexShrink: 1 } :
                                    { width: 220, justifyContent: "flex-start", pl: 2, flexShrink: 1 }
                            }
                        >
                            <SvgIcon
                                focusable={false}
                                component={FunexpectedIcon}
                                viewBox='0 0 153 14'
                                color="secondary"
                                // Same size as the dashboard drawer's wordmark (LeftDrawer).
                                sx={{ width: '180px', height: '17px' }}
                            />
                        </IconButton>
                    </Link>
                }
                {!matches && session && !showFunexpectedLogo &&
                    <IconButton onClick={() => { setOpenMobileMenu(true) }}>
                        <Menu />
                    </IconButton>
                }
                <Box sx={{ flexGrow: 1, flexShrink: 1 }} />
                {session && !props.hideProfileMenu &&
                    <Typography>{userName}</Typography>
                }
                {session && !props.hideProfileMenu &&
                    <IconButton color="inherit" component="div">
                        <AccountMenu />
                    </IconButton>
                }
                <MobileMenu
                    open={openMobileMenu}
                    handleClose={() => setOpenMobileMenu(false)}
                />
            </Toolbar>
        </AppBar>
    )
}